import Skeleton from '@mui/material/Skeleton';
import { Card, CardGroup } from '@ps/isp-web-component-library';
import React from 'react';

import LoadingStateWrapper from '@swf/sports/components/LoadingStateWrapper/LoadingStateWrapper';

import styles from './LoadingState.scss';

const SkeletonCompetitionItem = () => (
  <div className={styles.itemSkeleton}>
    <Skeleton variant="rectangular" height="21px" animation="pulse" />
  </div>
);

const LoadingState: React.FC = () => (
  <CardGroup hasFlushOnMobile isPadded>
    <Card as={LoadingStateWrapper}>
      <Skeleton
        variant="rectangular"
        height="45px"
        animation="pulse"
        className={styles.headerSkeleton}
      />

      <SkeletonCompetitionItem />
      <SkeletonCompetitionItem />
      <SkeletonCompetitionItem />
      <SkeletonCompetitionItem />
      <SkeletonCompetitionItem />
    </Card>
  </CardGroup>
);

export default LoadingState;
